module.exports = __webpack_public_path__ + "img/video-cover__son.c3fdd486.jpg";